import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const PendingTxnDeleteModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    deleteMode, submitted, transactionId,
    // event handlers
    onSubmit, onCancelClick,
    //
    deleteReason, onDeleteReasonChange, deleteReasonError, setDeleteReasonError
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Delete pending transaction'
    buttonLabel='Delete'
    cancelLabel='Cancel'
    isOpen={deleteMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputReadOnlyUI name='transactionId' label='Transaction id'
      required={true} value={transactionId}
    />
    <InputTextSF type='text'  name='deleteReason' label='Delete reason'
      maxLength={100} autoFocus={true}
      value={deleteReason} onChange={onDeleteReasonChange}
      error={deleteReasonError} setError={setDeleteReasonError}
    />
  </ModalFormUI>

export default PendingTxnDeleteModalUI
